var exports = {
  "container": "x4ddf2309--cf0ac9--container",
  "container--size-m": "x4ddf2309--cf0ac9--container--size-m",
  "container--size-s": "x4ddf2309--cf0ac9--container--size-s",
  "container--active": "x4ddf2309--cf0ac9--container--active",
};

module.exports = exports;
